import { MutableRefObject, useEffect } from 'react';
import { useSelector, useStore } from 'react-redux';

import { logArticleSectionAction } from '../../../bi';
import { selectArticleState } from '../../../common/selectors/helpCenter';

export const useCollapsibleComponentsBiTracker = (
  containerRef: MutableRefObject<HTMLElement | null>,
  articleId: string,
): void => {
  const store = useStore();
  const { isLoading } = useSelector(selectArticleState);

  useEffect(() => {
    if (isLoading) {
      return;
    }

    const sectionInteraction = (e: Event) => {
      const state = store.getState();
      const target = e.target as HTMLElement;
      const linkText = target?.textContent ?? '';
      const expand = target?.parentElement?.ariaExpanded === 'false';

      logArticleSectionAction(state, {
        expand,
        linkText,
        articleId,
      });
    };
    const collapsibleComponents = containerRef.current?.querySelectorAll<HTMLElement>('.collapsible-heading');

    collapsibleComponents?.forEach((collapsibleComponent) =>
      collapsibleComponent.addEventListener('click', sectionInteraction),
    );

    return () =>
      collapsibleComponents?.forEach((collapsibleComponent) =>
        collapsibleComponent.removeEventListener('click', sectionInteraction),
      );
  }, [isLoading]);
};
